<template>
  <v-expansion-panel>
    <v-expansion-panel-title>
      <v-row no-gutters align="center">
        <v-col cols="6">
          <v-chip
            pill
            size="small"
            class="ml-1"
            variant="elevated"
            color="grey-lighten-3"
            text-color="black"
          >
            {{ formatHour(hour[0]) }}
          </v-chip>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-chip
            v-for="(count, type) in countTypes"
            :key="type"
            size="small"
            class="mr-2"
            :color="icons[type]?.color"
            variant="elevated"
          >
            {{ count }}
          </v-chip>
        </v-col>
      </v-row>
    </v-expansion-panel-title>
    <v-expansion-panel-text>
      <v-list>
        <DayReportLineListHourItem
          v-for="line in hour"
          :key="line.id"
          :item="line"
          :icons="icons"
        />
      </v-list>
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>

<script>
import { computed } from "vue";
import DayReportLineListHourItem from "./DayReportLineListHourItem.vue";
import { formatHourLabel } from "@/utils/dayReportLineGrouping";
import { useDayReportLinesStoreRefactor } from "@/stores/dayReportLinesStoreRefactor";

export default {
  name: "DayReportLineListHour",
  components: {
    DayReportLineListHourItem,
  },
  props: {
    hour: {
      type: Array,
      required: true,
    },
    index: {
      type: String,
      required: true,
    },
  },
  setup() {
    const dayReportLinesStore = useDayReportLinesStoreRefactor();

    return {
      icons: computed(() => dayReportLinesStore.icons),
    };
  },
  computed: {
    countTypes() {
      return this.hour.reduce((acc, line) => {
        acc[line.line_category] = (acc[line.line_category] || 0) + 1;
        return acc;
      }, {});
    },
  },
  methods: {
    getChipColor() {
      return "rgba(255, 255, 255, 0.2)";
    },
    formatHour(line) {
      // Amsterdam (NL) time from the server's `date`/`time` strings — never the
      // device-local reinterpretation of date_time.
      return formatHourLabel(line);
    },
  },
};
</script>

<style scoped>
.v-expansion-panel-title {
  padding: 8px 16px;
}
.v-chip {
  margin-top: 4px;
}
</style>
